/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Extra_Point_0_TextInputs */

const en_visa_e2_extra_point_0_text = /** @type {(inputs: Visa_E2_Extra_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treaty-based eligibility depends in part on the nationality and ownership structure connected to the business and applicant.`)
};

const pt_visa_e2_extra_point_0_text = /** @type {(inputs: Visa_E2_Extra_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A elegibilidade baseada em tratado depende em parte da nacionalidade e estrutura de propriedade conectadas à empresa e ao solicitante.`)
};

const es_visa_e2_extra_point_0_text = /** @type {(inputs: Visa_E2_Extra_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La elegibilidad basada en tratado depende en parte de la nacionalidad y la estructura de propiedad conectadas a la empresa y al solicitante.`)
};

/**
* | output |
* | --- |
* | "Treaty-based eligibility depends in part on the nationality and ownership structure connected to the business and applicant." |
*
* @param {Visa_E2_Extra_Point_0_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_extra_point_0_text = /** @type {((inputs?: Visa_E2_Extra_Point_0_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Extra_Point_0_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_extra_point_0_text(inputs)
	if (locale === "es") return es_visa_e2_extra_point_0_text(inputs)
	return en_visa_e2_extra_point_0_text(inputs)
});